import { MenuItems } from '../enums/menu-items.enum';
import { Permissions } from '../enums/permissions.enum';
import { AuthorizationRecord } from '../types/authorization-record.type';

export const hasUserMenuAccess = (menuName: MenuItems, authorizationRecord: AuthorizationRecord | null) => {
  if (!authorizationRecord || !authorizationRecord[menuName]) {
    return false;
  }

  if (authorizationRecord[menuName]?.includes(Permissions.READ) || authorizationRecord[menuName]?.includes(Permissions.WRITE)) {
    return true;
  }

  return false;
};
